import { AspectRatio, CampaignAddon, ClipType } from '../../gql/types'
import { clipTypeLocalizedString } from '../../utils/GqlStrings'
import {
  mapAspectRatioToText,
  mapCampaignAddonsTypeToTextSimple,
} from '../../utils/mappers'
import { Badge, BadgeSize, BadgeType } from '../Badge'

const ClipTypeBadge = ({
  type,
  aspectRatio,
  addon,
}: {
  type: ClipType
  aspectRatio: AspectRatio
  addon: CampaignAddon
}) => {
  let badgeType
  switch (type) {
    case ClipType.firstVersion:
      badgeType = BadgeType.success
      break
    case ClipType.editedVersion:
      badgeType = BadgeType.blue
      break
    case ClipType.hook:
      badgeType = BadgeType.indigo
      break
    case ClipType.addon:
      badgeType = BadgeType.purple
      break
    case ClipType.rawFile:
      badgeType = BadgeType.gray
      break
    case ClipType.otherFile:
      badgeType = BadgeType.gray
      break
    default:
      throw new Error(`Invalid clip type ${type}`)
  }

  // if (type === ClipType.addon) {
  //   return (
  //     <Badge
  //       type={badgeType}
  //       text={mapCampaignAddonsTypeToTextSimple(addon)}
  //       size={BadgeSize.small}
  //     />
  //   )
  // }

  return (
    <div className='flex flex-col space-y-1'>
      <div>
        <Badge
          type={badgeType}
          text={clipTypeLocalizedString(type)}
          size={BadgeSize.small}
        />
      </div>
      {(type === ClipType.firstVersion || type === ClipType.editedVersion) && (
        <Badge
          type={BadgeType.blue}
          text={mapAspectRatioToText(aspectRatio)}
          size={BadgeSize.small}
        />
      )}
      {type === ClipType.addon && (
        <Badge
          type={BadgeType.blue}
          text={mapCampaignAddonsTypeToTextSimple(addon)}
          size={BadgeSize.small}
        />
      )}
    </div>
  )
}

export { ClipTypeBadge }
